import {handleActions} from 'redux-actions';

import {
    CONTENT_ITEMS_LIST_SET,
    CONTENT_ITEMS_LIST_RESET,
} from './ContentItemsListActions';

export const setItems = (state: any, {payload}:any) => {
    if (payload)
        return {
            rows: payload.rows,
            total: payload.total,
        };
    
    return state;
};

export const resetItems = () => {
    return initialState;
};

const initialState = {
    rows: [],
    total: 0,
};

const handlers = {
    [CONTENT_ITEMS_LIST_SET]: setItems,
    [CONTENT_ITEMS_LIST_RESET]: resetItems,
};

export default handleActions(handlers, initialState);
